import * as z from "zod";

export const ShippingAddressToUpdateSchema = z.object({
  address1: z.string().describe("Street address"),
  address2: z
    .string()
    .nullable()
    .describe("Optional: Apartment number or suite number"),
  city: z.string().nullable().describe("Optional: City of the street address"),
  provinceCode: z
    .string()
    .nullable()
    .describe("Optional: Province code of the street address"),
  zip: z
    .string()
    .nullable()
    .describe("Optional: Zip code of the street address"),
  countryCode: z
    .string()
    .nullable()
    .describe("Optional: Country code of the street address"),
  firstName: z
    .string()
    .nullable()
    .describe("Optional: First name of the customer"),
  lastName: z
    .string()
    .nullable()
    .describe("Optional: Last name of the customer"),
});
export type ShippingAddressToUpdate = z.infer<
  typeof ShippingAddressToUpdateSchema
>;

export const ConfirmUpdateOrderShippingAddressSchema = z.object({
  updatedShippingAddress: ShippingAddressToUpdateSchema,
});

export type ConfirmUpdateOrderShippingAddress = z.infer<
  typeof ConfirmUpdateOrderShippingAddressSchema
>;
